import { PreWraper } from '@components/shared/wraper/PreWraper'
import React from 'react'
import { SummaryProgramHeading } from '../Heading'
import { LecturerProfileList } from './component/LecturerProfileList'

type Props = {
  lecturerProfile: {
    id: number
    name: string
    imagePath: string
    shortIntroduction: string
  }[]
}

export const SummaryProgramLecturerProfile = ({
  lecturerProfile,
}: Props): JSX.Element => (
  <div className="flex flex-col mt-[7.5vw] lg:mt-[3.1vw]">
    <SummaryProgramHeading heading="担当講師のご紹介" />

    <div className="mt-[6vw] lg:mt-[2.3vw]">
      <div className="text-[3.7vw] lg:text-[1.1vw] leading-[7.5vw] lg:leading-[2.2vw] text-[#666666]">
        {lecturerProfile.map((lecturer, i) => (
          <div key={i} className="mt-[5.8vw] first:mt-0 lg:mt-[2.2vw]">
            <LecturerProfileList {...lecturer} />
          </div>
        ))}
        <div className="mt-[8vw] lg:mt-[2.3vw]">
          <PreWraper
            text={`※ご希望の日時や講師の都合によっていずれかの担当講師が決定されます。\n※上記以外の講師が担当する場合もございますのでご了承ください。`}
          />
        </div>
      </div>
    </div>
  </div>
)
